import SiteScreen from './site-screen';

export default SiteScreen;
